export default __webpack_public_path__ + "static/media/asphaltFront1.24af8483.png";